export default import.meta.ROLLDOWN_FILE_URL_ai$EhcgWXFrUmp9a730ngA